import React from 'react';
import { Link } from 'react-router-dom';
import logo from 'images/logo-dark.png';
import * as S from './styles';

function Navigation() {
  return (
    <S.Wrapper >
      <nav>
        <Link to="/">
          <img src={logo} alt="" />
        </Link>
        <S.DesktopNav>
          <Link to="/#buy-tickets">
            <button data-id="LGZlbd" className="filled">
              sold out
            </button>
          </Link>
        </S.DesktopNav>
        <S.NavIcon>
          <Link to="/#buy-tickets">
            <button data-id="LGZlbd" className="filled">
              sold out
            </button>
          </Link>
        </S.NavIcon>
      </nav>
    </S.Wrapper>
  );
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/NavigationRelative/index.js